import { render, staticRenderFns } from "./JsonDrawer.vue?vue&type=template&id=575e4f74&scoped=true"
import script from "./JsonDrawer.vue?vue&type=script&lang=js"
export * from "./JsonDrawer.vue?vue&type=script&lang=js"
import style0 from "./JsonDrawer.vue?vue&type=style&index=0&id=575e4f74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575e4f74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('575e4f74')) {
      api.createRecord('575e4f74', component.options)
    } else {
      api.reload('575e4f74', component.options)
    }
    module.hot.accept("./JsonDrawer.vue?vue&type=template&id=575e4f74&scoped=true", function () {
      api.rerender('575e4f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGenerator/index/JsonDrawer.vue"
export default component.exports